export const properties = {
    RESOURCE: '',
    URL: '',
    MEDIA_PATH: 'header/'
}